import { render, staticRenderFns } from "./InvoiceStatusCell.vue?vue&type=template&id=4935035d&"
import script from "./InvoiceStatusCell.vue?vue&type=script&lang=js&"
export * from "./InvoiceStatusCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports